export default __webpack_public_path__ + "static/media/hht2_ep_11.82a8f42a.png";